import { Stack, Typography } from '@mui/material';
import theme from '../../theme';
import { ArticleOutlined } from '@mui/icons-material';

const ReviewCount = ({ reviewCount, variant = 'card' }) => {
  const iconSizes = {
    card: { xs: 12, md: 16 },
    detail: 16,
    compact: 12,
    homeFeature: { xs: 16, md: 16 },
  };

  const typoFontSizes = {
    card: { xs: 12, md: 14 },
    detail: 14,
    compact: 12,
    homeFeature: { xs: 14, md: 14 },
  };

  const iconSize = iconSizes[variant];
  const typoFontSize = typoFontSizes[variant];

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <ArticleOutlined sx={{ fontSize: iconSize, color: theme.palette.black[3] }} />
      <Typography
        sx={{ fontSize: typoFontSize, color: theme.palette.black[4], whiteSpace: 'nowrap' }}
      >
        {reviewCount}
      </Typography>
    </Stack>
  );
};

export default ReviewCount;
